"use client";

import React from "react";
import Icon from "@/components/ui/AppIcon";

export default function SocialShareBar() {
  return (
    <div className="px-6 pb-4 fade-in-up delay-700">
      <a
        href="https://book.titan.email/dannyclans/bkcalldc"
        target="_blank"
        rel="noopener noreferrer"
        className="w-full flex items-center justify-center gap-2 py-3 rounded-full border border-border text-muted hover:text-primary hover:border-primary transition-all font-sans font-medium"
        style={{ fontSize: "13px" }}
        aria-label="Schedule Call"
      >
        <Icon name="CalendarIcon" size={16} variant="outline" />
        <span>Schedule Call</span>
      </a>
    </div>
  );
}